import { useConfig } from '@/composables';

const remoteHazardAssetsUrl = useConfig().value.remoteHazardAssets.iconAssetsPathSvg;

export const WARNING_HAZARD_ICONS = {
  // Air Quality
  'ew-air-quality--emergency-warning': `${remoteHazardAssetsUrl}/ew-air-quality--emergency-warning.svg?url`,
  'ew-air-quality--watch-and-act': `${remoteHazardAssetsUrl}/ew-air-quality--watch-and-act.svg?url`,
  'ew-air-quality--advice': `${remoteHazardAssetsUrl}/ew-air-quality--advice.svg?url`,

  // Blizzard
  'ew-blizzard--emergency-warning': `${remoteHazardAssetsUrl}/ew-blizzard--emergency-warning.svg?url`,
  'ew-blizzard--watch-and-act': `${remoteHazardAssetsUrl}/ew-blizzard--watch-and-act.svg?url`,
  'ew-blizzard--advice': `${remoteHazardAssetsUrl}/ew-blizzard--advice.svg?url`,

  // Extreme Cold
  'ew-extreme-cold--emergency-warning': `${remoteHazardAssetsUrl}/ew-extreme-cold--emergency-warning.svg?url`,
  'ew-extreme-cold--watch-and-act': `${remoteHazardAssetsUrl}/ew-extreme-cold--watch-and-act.svg?url`,
  'ew-extreme-cold--advice': `${remoteHazardAssetsUrl}/ew-extreme-cold--advice.svg?url`,

  // Flash Flood
  'ew-flash-flood--emergency-warning': `${remoteHazardAssetsUrl}/ew-flash-flood--emergency-warning.svg?url`,
  'ew-flash-flood--watch-and-act': `${remoteHazardAssetsUrl}/ew-flash-flood--watch-and-act.svg?url`,
  'ew-flash-flood--advice': `${remoteHazardAssetsUrl}/ew-flash-flood--advice.svg?url`,

  // Freezing Rain
  'ew-freezing-rain--emergency-warning': `${remoteHazardAssetsUrl}/ew-freezing-rain--emergency-warning.svg?url`,
  'ew-freezing-rain--watch-and-act': `${remoteHazardAssetsUrl}/ew-freezing-rain--watch-and-act.svg?url`,
  'ew-freezing-rain--advice': `${remoteHazardAssetsUrl}/ew-freezing-rain--advice.svg?url`,

  // Generic (Other Warning)
  'ew-other-warning--emergency-warning': `${remoteHazardAssetsUrl}/ew-other-warning--emergency-warning.svg?url`,
  'ew-other-warning--watch-and-act': `${remoteHazardAssetsUrl}/ew-other-warning--watch-and-act.svg?url`,

  // Ice Jam
  'ew-ice-jam--emergency-warning': `${remoteHazardAssetsUrl}/ew-ice-jam--emergency-warning.svg?url`,
  'ew-ice-jam--watch-and-act': `${remoteHazardAssetsUrl}/ew-ice-jam--watch-and-act.svg?url`,
  'ew-ice-jam--advice': `${remoteHazardAssetsUrl}/ew-ice-jam--advice.svg?url`,

  // Lake Flooding
  'ew-lake-flooding--emergency-warning': `${remoteHazardAssetsUrl}/ew-lake-flooding--emergency-warning.svg?url`,
  'ew-lake-flooding--watch-and-act': `${remoteHazardAssetsUrl}/ew-lake-flooding--watch-and-act.svg?url`,
  'ew-lake-flooding--advice': `${remoteHazardAssetsUrl}/ew-lake-flooding--advice.svg?url`,

  // Power Outage (EMO graduated levels)
  'ew-power-outage--emergency-warning': `${remoteHazardAssetsUrl}/ew-power-outage--emergency-warning.svg?url`,
  'ew-power-outage--watch-and-act': `${remoteHazardAssetsUrl}/ew-power-outage--watch-and-act.svg?url`,

  // River Flooding
  'ew-river-flooding--emergency-warning': `${remoteHazardAssetsUrl}/ew-river-flooding--emergency-warning.svg?url`,
  'ew-river-flooding--watch-and-act': `${remoteHazardAssetsUrl}/ew-river-flooding--watch-and-act.svg?url`,
  'ew-river-flooding--advice': `${remoteHazardAssetsUrl}/ew-river-flooding--advice.svg?url`,

  // Seasonal Overland Flooding
  'ew-seasonal-overland-flooding--emergency-warning': `${remoteHazardAssetsUrl}/ew-seasonal-overland-flooding--emergency-warning.svg?url`,
  'ew-seasonal-overland-flooding--watch-and-act': `${remoteHazardAssetsUrl}/ew-seasonal-overland-flooding--watch-and-act.svg?url`,
  'ew-seasonal-overland-flooding--advice': `${remoteHazardAssetsUrl}/ew-seasonal-overland-flooding--advice.svg?url`,

  // Severe Winter Weather
  'ew-severe-winter-weather--emergency-warning': `${remoteHazardAssetsUrl}/ew-severe-winter-weather--emergency-warning.svg?url`,
  'ew-severe-winter-weather--watch-and-act': `${remoteHazardAssetsUrl}/ew-severe-winter-weather--watch-and-act.svg?url`,
  'ew-severe-winter-weather--advice': `${remoteHazardAssetsUrl}/ew-severe-winter-weather--advice.svg?url`,

  // Tornado
  'ew-tornado--emergency-warning': `${remoteHazardAssetsUrl}/ew-tornado--emergency-warning.svg?url`,
  'ew-tornado--watch-and-act': `${remoteHazardAssetsUrl}/ew-tornado--watch-and-act.svg?url`,
  'ew-tornado--advice': `${remoteHazardAssetsUrl}/ew-tornado--advice.svg?url`,

  // Bushfire
  'ew-bushfire--emergency-warning': `${remoteHazardAssetsUrl}/ew-bushfire--emergency-warning.svg?url`,
  'ew-bushfire--watch-and-act': `${remoteHazardAssetsUrl}/ew-bushfire--watch-and-act.svg?url`,
  'ew-bushfire--advice': `${remoteHazardAssetsUrl}/ew-bushfire--advice.svg?url`,

  // Coastal Hazards
  'ew-coastal-hazard--emergency-warning': `${remoteHazardAssetsUrl}/ew-coastal-hazard--emergency-warning.svg`,
  'ew-coastal-hazard--watch-and-act': `${remoteHazardAssetsUrl}/ew-coastal-hazard--watch-and-act.svg`,
  'ew-coastal-hazard--advice': `${remoteHazardAssetsUrl}/ew-coastal-hazard--advice.svg`,

  // Cyclone
  'ew-cyclone--emergency-warning': `${remoteHazardAssetsUrl}/ew-cyclone--emergency-warning.svg?url`,
  'ew-cyclone--watch-and-act': `${remoteHazardAssetsUrl}/ew-cyclone--watch-and-act.svg?url`,
  'ew-cyclone--advice': `${remoteHazardAssetsUrl}/ew-cyclone--advice.svg?url`,

  // Damaging Winds
  'ew-damaging-winds--emergency-warning': `${remoteHazardAssetsUrl}/ew-damaging-winds--emergency-warning.svg?url`,
  'ew-damaging-winds--watch-and-act': `${remoteHazardAssetsUrl}/ew-damaging-winds--watch-and-act.svg?url`,
  'ew-damaging-winds--advice': `${remoteHazardAssetsUrl}/ew-damaging-winds--advice.svg?url`,

  // Earthquake
  'ew-earthquake-alert': `${remoteHazardAssetsUrl}/ew-earthquake-alert.svg?url`,
  'ew-earthquake-final-alert': `${remoteHazardAssetsUrl}/ew-earthquake-final-alert.svg?url`,

  // Flood
  'ew-flood--emergency-warning': `${remoteHazardAssetsUrl}/ew-flood--emergency-warning.svg?url`,
  'ew-flood--watch-and-act': `${remoteHazardAssetsUrl}/ew-flood--watch-and-act.svg?url`,
  'ew-flood--advice': `${remoteHazardAssetsUrl}/ew-flood--advice.svg?url`,

  // Hazardous Materials
  'ew-hazmat-controlled-contained': `${remoteHazardAssetsUrl}/ew-hazmat-controlled-contained.svg?url`,
  'ew-hazmat-general-warning': `${remoteHazardAssetsUrl}/ew-hazmat-general-warning.svg?url`,
  'ew-hazardous-materials-warning': `${remoteHazardAssetsUrl}/ew-hazardous-materials-warning.svg?url`,

  // Heatwave
  'ew-heatwave--emergency-warning': `${remoteHazardAssetsUrl}/ew-heatwave--emergency-warning.svg?url`,
  'ew-heatwave--watch-and-act': `${remoteHazardAssetsUrl}/ew-heatwave--watch-and-act.svg?url`,
  'ew-heatwave--advice': `${remoteHazardAssetsUrl}/ew-heatwave--advice.svg?url`,

  // Human Pandemic Warning / State-wide Warning
  'ew-state-wide-warning': `${remoteHazardAssetsUrl}/ew-warning-state-wide.svg?url`,
  'ew-human-pandemic-warning': `${remoteHazardAssetsUrl}/ew-human-pandemic-warning.svg?url`,

  // Smoke or Other Alert
  'ew-smoke-alert': `${remoteHazardAssetsUrl}/ew-smoke-alert.svg?url`,
  'ew-other-warning': `${remoteHazardAssetsUrl}/ew-other-warning.svg?url`,

  // Storm
  'ew-storm--emergency-warning': `${remoteHazardAssetsUrl}/ew-storm--emergency-warning.svg?url`,
  'ew-storm--advice': `${remoteHazardAssetsUrl}/ew-storm--advice.svg?url`,
  'ew-storm--watch-and-act': `${remoteHazardAssetsUrl}/ew-storm--watch-and-act.svg?url`,

  // Storm Surge
  'ew-storm-surge--emergency-warning': `${remoteHazardAssetsUrl}/ew-storm-surge--emergency-warning.svg?url`,
  'ew-storm-surge--watch-and-act': `${remoteHazardAssetsUrl}/ew-storm-surge--watch-and-act.svg?url`,
  'ew-storm-surge--advice': `${remoteHazardAssetsUrl}/ew-storm-surge--advice.svg?url`,

  // Structure Fire
  'ew-structure-fire-warning': `${remoteHazardAssetsUrl}/ew-structure-fire-warning.svg?url`,
  'ew-structure-fire-contained-controlled': `${remoteHazardAssetsUrl}/ew-structure-fire-contained-controlled.svg?url`,

  // Tsunami
  'ew-tsunami-all-clear': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-land-warning': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-marine-warning': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-watch': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,
  'ew-tsunami-warning': `${remoteHazardAssetsUrl}/ew-tsunami-warning.svg?url`,

  // Power Outage
  'ew-power-outage': `${remoteHazardAssetsUrl}/ew-power-outage.svg?url`,

  // Total Fire Ban
  'ew-total-fire-ban': `${remoteHazardAssetsUrl}/ew-total-fire-ban.svg?url`,

  // Community Information
  'ew-community-information': `${remoteHazardAssetsUrl}/ew-community-information.svg?url`,

  // General Warnings
  'ew-advice': `${remoteHazardAssetsUrl}/ew-advice.svg?url`,
  'ew-alert': `${remoteHazardAssetsUrl}/ew-alert.svg?url`,
  'ew-warning-location-specific': `${remoteHazardAssetsUrl}/ew-warning-location-specific.svg?url`,
  'ew-warning-state-wide': `${remoteHazardAssetsUrl}/ew-warning-state-wide.svg?url`,

  // Person Alerts
  'ew-amber-alert--emergency-warning': `${remoteHazardAssetsUrl}/ew-amber-alert--emergency-warning.svg?url`,
  'ew-dangerous-person--watch-and-act': `${remoteHazardAssetsUrl}/ew-dangerous-person--watch-and-act.svg?url`,
  'ew-missing-vulnerable-person--watch-and-act': `${remoteHazardAssetsUrl}/ew-missing-vulnerable-person--watch-and-act.svg?url`,
  'ew-silver-alert--watch-and-act': `${remoteHazardAssetsUrl}/ew-silver-alert--watch-and-act.svg?url`,
};
